import { Observable, of } from 'rxjs';
import { IPermissions } from './../../interfaces/modules-mango.interface';
import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RolesUserService {
  private permissionsUser: IPermissions = {} as IPermissions;
  public getPermissions = new EventEmitter<IPermissions>();
  constructor() {}

  public setPermissions(permission: IPermissions) {
    this.permissionsUser = permission;
    this.getPermissions.emit(permission);
  }

  public getPermissionsObject(): IPermissions {
    return this.permissionsUser;
  }

  public resetPermissions() {
    this.permissionsUser = {} as IPermissions;
    this.getPermissions.emit(this.permissionsUser);
  }
}
